import { sendWebviewMobileMessage } from '@lumapps/mobile-webview/message-emit';

import { RouterApiOptions } from '../api';
import { Route } from '../types';
import { addLocationOriginToUrl, createUrl } from '../utils';
import { routerApi } from './router';

/**
 * In the webview app we don't really redirect to anywhere, we just notify the host mobile app where it needs to go
 * (mobilePageDescriptor) or give it a fallback URL (so it can open it in a browser).
 * Except for the "web-internal" page descriptor
 */
export const webviewRouterApi = {
    redirect: (route: Route, history?: any, options: RouterApiOptions = {}) => {
        const url = addLocationOriginToUrl(createUrl(route));

        const page = route.mobilePageDescriptor || { type: 'unknown' };

        /** Enable redirects for a specific mobile page descriptor */
        if (page.type === 'web-internal') {
            routerApi.redirect(route, history, options);
        } else {
            sendWebviewMobileMessage({ type: 'redirect', payload: { ...page, url } });
        }
    },
};
